module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Benutzer erfassen","firstNameLabel":"Vorname","lastNameLabel":"Nachname","companyNameLabel":"Firma","emailLabel":"E-Mail","passwordLabel":"Passwort","submitButtonLabel":"Speichern","errorEmailInvalid":"Ungültige E-Mail-Adresse","errorHeader":"Beim Speichern ist ein Fehler aufgetreten"}}')
  delete Component.options._Ctor
}
